const constantes = {
  appVersion: "1.0.0",
  apiVersion: "1",
  AMBProducao: process.env.REACT_APP_API,
  BASENAME: "DrPayLogin",
};

export default constantes;
